import logo from "../assets/images/logo.png";
import error from "../assets/images/error.svg";
import prePattern from "../assets/images/prePattern.gif";
import galleryLanding from "../assets/images/galleryLanding.webp";
import pattern from "../assets/images/pattern.webp";
import bgPattern from "../assets/images/bgPattern.webp";
import densePattern from "../assets/images/densePattern.webp";


import testiTop from "../assets/images/testiTop.webp";
import testiA from "../assets/images/testiA.jpg";
import testimonialCenter from "../assets/images/testimonialBg.webp";
import testiB from "../assets/images/testiB.jpg";
import testiBottomLeft from "../assets/images/testiBottomLeft.jpg";
import testiBottomRight from "../assets/images/testibottomRight.jpg";

export const images = {
  logo,
  error,
  prePattern,
  galleryLanding,
  pattern,
  bgPattern,
  densePattern,

  testiTop,
  testiA,
  testimonialCenter,
  testiB,
  testiBottomLeft,
  testiBottomRight,
  
};
